import styled, { css } from "styled-components";

interface StyledCheckboxProps {
  $size: "large" | "small";
  $mode: "left" | "right";
  $color: "primary" | "red-0";
  $hovered: boolean;
  $disabled: boolean;
}

const styledHoveredCheckbox = ($color: "primary" | "red-0") => {
  if ($color === "primary") {
    return css`
      & > .checkbox {
        border: 0.1rem solid var(--pri-blue-3);
      }
      & > .label {
        color: var(--pri-blue-3);
      }
    `;
  }
  if ($color === "red-0") {
    return css`
      & > .checkbox {
        border: 0.1rem solid var(--sys-red-0);
      }
      & > .label {
        color: var(--sys-red-0);
      }
    `;
  }
};

export const StyledCheckboxLabel = styled.label<StyledCheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  ${({ $mode }) =>
    $mode === "right" &&
    css`
      flex-flow: row-reverse nowrap;
    `}
  ${({ $size }) => {
    if ($size === "large") {
      return css`
        gap: 0.8rem;
        & > .label {
          font: var(--label-small-400);
        }
      `;
    }
    if ($size === "small") {
      return css`
        gap: 0.4rem;
        & > .label {
          font: var(--label-medium-400);
        }
      `;
    }
  }}
  ${({ $disabled }) =>
    $disabled
      ? css`
          cursor: default;
        `
      : css`
          cursor: pointer;
        `}
  & > input[type="checkbox"] {
    display: none;
  }

  & > .checkbox {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.1rem solid var(--bg-gray-2);
    border-radius: 0.2rem;

    ${({ $size }) => {
      if ($size === "large") {
        return css`
          width: 1.6rem;
          height: 1.6rem;
        `;
      }
      if ($size === "small") {
        return css`
          width: 1.2rem;
          height: 1.2rem;
        `;
      }
    }}
  }

  & > .label {
    color: var(--text-gray-4);
    font: ${({ $size }) =>
      $size === "large" ? "var(--label-medium-400)" : "var(--label-small-400)"};
  }

  & > input:checked {
    & ~ .checkbox {
      border: ${({ $color }) =>
        $color === "primary"
          ? "0.1rem solid var(--pri-blue-3)"
          : "0.1rem solid var(--sys-red-0)"};
      background-color: ${({ $color }) =>
        $color === "primary" ? "var(--pri-blue-3)" : "var(--sys-red-0)"};
    }
    & ~ .label {
      color: var(--text-gray-strong);
    }
  }

  & > input:disabled ~ .checkbox,
  & > input:disabled ~ .label {
    opacity: 0.4;
    pointer-events: none;
    color: var(--bg-gray-2);
  }
  &:hover {
    ${({ $color }) => styledHoveredCheckbox($color)}
  }
  ${({ $hovered, $color }) => $hovered && styledHoveredCheckbox($color)}
`;
